import { render, staticRenderFns } from "./task-info.vue?vue&type=template&id=79a1a4e0&scoped=true"
import script from "./task-info.vue?vue&type=script&lang=js"
export * from "./task-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1a4e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a1a4e0')) {
      api.createRecord('79a1a4e0', component.options)
    } else {
      api.reload('79a1a4e0', component.options)
    }
    module.hot.accept("./task-info.vue?vue&type=template&id=79a1a4e0&scoped=true", function () {
      api.rerender('79a1a4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/task-info.vue"
export default component.exports